<kanzi-ui-main-card
  [title]="
    ubicacion()?.display_name || ubicacion()?.name || ('locations.ubicaciones.detail.title' | translate)
  "
  [description]="'locations.ubicaciones.detail.description' | translate"
>
  <ng-template kTemplate="rightTopContent">
    <div class="flex gap-2">
      <p-button
        icon="pi pi-arrow-left"
        [outlined]="true"
        severity="primary"
        (onClick)="onBack()"
        [pTooltip]="'locations.ubicaciones.detail.back' | translate"
        tooltipPosition="bottom"
      ></p-button>
      <p-button
        icon="pi pi-pencil"
        severity="success"
        (onClick)="onEdit()"
        [disabled]="isLoading()"
        [pTooltip]="'locations.ubicaciones.detail.edit' | translate"
        tooltipPosition="bottom"
      ></p-button>
      <p-button
        icon="pi pi-trash"
        severity="danger"
        (onClick)="onDelete()"
        [disabled]="isLoading()"
        [loading]="isDeleting()"
        [pTooltip]="'locations.ubicaciones.detail.delete' | translate"
        tooltipPosition="bottom"
      ></p-button>
    </div>
  </ng-template>

  <!-- Loading Skeleton -->
  @if (isLoading()) {
  <div class="grid">
    <div class="col-12 lg:col-8">
      <p-card>
        <p-skeleton height="2rem" styleClass="mb-3"></p-skeleton>
        <p-skeleton height="1.5rem" styleClass="mb-3"></p-skeleton>
        <p-skeleton height="1.5rem" styleClass="mb-3"></p-skeleton>
        <p-skeleton height="4rem"></p-skeleton>
      </p-card>
    </div>
  </div>
  }

  <!-- Ubicación Details -->
  @if (!isLoading() && ubicacion()) {
  <div class="grid">
    <div class="col-12 lg:col-8">
      <!-- Main Info Card -->
      <p-card styleClass="mb-3">
        <div class="flex flex-column gap-3">
          <!-- Header with gradient -->
          <div
            class="flex align-items-center justify-content-between pb-3 border-bottom-1 surface-border"
          >
            <div class="flex align-items-center gap-3">
              <div
                class="flex align-items-center justify-content-center bg-primary border-circle"
                style="width: 3rem; height: 3rem"
              >
                <i class="pi pi-sitemap text-white text-xl"></i>
              </div>
              <div>
                <h2 class="m-0 text-900 font-semibold">
                  {{ ubicacion()?.name }}
                </h2>
                @if (ubicacion()?.display_name && ubicacion()?.display_name !==
                ubicacion()?.name) {
                <p class="m-0 mt-1 text-600">{{ ubicacion()?.display_name }}</p>
                }
              </div>
            </div>
            <p-tag
              [value]="ubicacion()?.type?.name || ('locations.ubicaciones.detail.noType' | translate)"
              severity="info"
              styleClass="text-base"
            ></p-tag>
          </div>

          <!-- Metadata Grid -->
          <div class="grid mt-2">
            <!-- ID -->
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <span class="text-500 text-sm font-semibold">{{ 'locations.ubicaciones.detail.id' | translate }}</span>
                <span class="text-900">{{ ubicacion()?.id }}</span>
              </div>
            </div>

            <!-- External ID -->
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <span class="text-500 text-sm font-semibold">{{ 'locations.ubicaciones.detail.externalId' | translate }}</span>
                <span class="text-900">{{
                  ubicacion()?.external_id || '-'
                }}</span>
              </div>
            </div>

            <!-- Type -->
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <span class="text-500 text-sm font-semibold">{{ 'locations.ubicaciones.detail.type' | translate }}</span>
                <span class="text-900">{{
                  ubicacion()?.type?.name || '-'
                }}</span>
              </div>
            </div>

            <!-- Zone Type -->
            @if (ubicacion()?.zone_type) {
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <span class="text-500 text-sm font-semibold">
                  {{ 'locations.ubicaciones.detail.zoneType' | translate }}
                </span>
                <p-tag
                  [value]="zoneTypeLabels[ubicacion()?.zone_type!] || ubicacion()?.zone_type"
                  severity="warning"
                ></p-tag>
              </div>
            </div>
            }

            <!-- Coordinates (if available) -->
            @if (ubicacion()?.longitude !== null && ubicacion()?.latitude !==
            null) {
            <div class="col-12">
              <p-divider></p-divider>
              <div class="grid">
                <div class="col-6">
                  <div class="flex flex-column gap-1">
                    <span class="text-500 text-sm font-semibold">{{ 'locations.ubicaciones.detail.longitude' | translate }}</span>
                    <span class="text-900">{{ ubicacion()?.longitude }}</span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="flex flex-column gap-1">
                    <span class="text-500 text-sm font-semibold">{{ 'locations.ubicaciones.detail.latitude' | translate }}</span>
                    <span class="text-900">{{ ubicacion()?.latitude }}</span>
                  </div>
                </div>
              </div>
            </div>
            }

            <!-- Description -->
            @if (ubicacion()?.description) {
            <div class="col-12">
              <p-divider></p-divider>
              <div class="flex flex-column gap-1">
                <span class="text-500 text-sm font-semibold">{{ 'locations.ubicaciones.detail.descriptionLabel' | translate }}</span>
                <p class="text-900 m-0 white-space-pre-wrap">
                  {{ ubicacion()?.description }}
                </p>
              </div>
            </div>
            }
          </div>
        </div>
      </p-card>

      <!-- Timestamps Card -->
      <p-card [header]="'locations.ubicaciones.detail.systemInfo' | translate">
        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="flex flex-column gap-1">
              <span class="text-500 text-sm font-semibold"
                >{{ 'locations.ubicaciones.detail.createdAt' | translate }}</span
              >
              <span class="text-900">{{ ubicacion()?.created }}</span>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="flex flex-column gap-1">
              <span class="text-500 text-sm font-semibold"
                >{{ 'locations.ubicaciones.detail.modifiedAt' | translate }}</span
              >
              <span class="text-900">{{ ubicacion()?.modified }}</span>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <!-- Sidebar -->
    <div class="col-12 lg:col-4">
      <!-- Actions Card -->
      <p-card [header]="'locations.ubicaciones.detail.actions' | translate">
        <div class="flex flex-column gap-2">
          <p-button
            [label]="'locations.ubicaciones.detail.editAction' | translate"
            icon="pi pi-pencil"
            severity="success"
            [outlined]="true"
            class="w-full"
            (onClick)="onEdit()"
          ></p-button>
          <p-button
            [label]="'locations.ubicaciones.detail.deleteAction' | translate"
            icon="pi pi-trash"
            severity="danger"
            [outlined]="true"
            class="w-full"
            (onClick)="onDelete()"
            [loading]="isDeleting()"
          ></p-button>
        </div>
      </p-card>
    </div>
  </div>
  }

  <!-- Error State -->
  @if (ubicacionQuery.isError()) {
  <p-message
    severity="error"
    [text]="'locations.ubicaciones.detail.errorMessage' | translate"
  ></p-message>
  }
</kanzi-ui-main-card>

<p-confirmDialog></p-confirmDialog>
